export const isEighteenOrMore = (birthDate) => {
    const minDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
    return minDate <= new Date();
};
